import { gql } from "@apollo/client"
import styled from "@emotion/styled"
import { mq, Text, theme } from "@pallet-hq/hegel"
import { DesktopOnly } from "components/atoms"
import Image from "components/Image"
import { WelcomeFallbackVersion_applylist } from "__generated__/WelcomeFallbackVersion_applylist"
import BackgroundImage from "./BackgroundImage"
import ButtonSection from "./ButtonSection"

const FallbackVersionFragment = gql`
    fragment WelcomeFallbackVersion_applylist on ApplylistType {
        id
        curatorName
        curatorAvatar {
            source
        }
        group {
            id
            name
            description
        }
    }
`

type FallbackVersionProps = {
    applylist: WelcomeFallbackVersion_applylist
}

const FallbackVersion = ({ applylist }: FallbackVersionProps) => {
    const group = applylist.group!

    return (
        <>
            <Background>
                <BGImage>
                    <BackgroundImage />
                </BGImage>
                <Layout>
                    <CuratorInfo>
                        <CuratorImage
                            width={24}
                            height={24}
                            borderRadius="100%"
                            src={applylist.curatorAvatar.source}
                            colorSlug=""
                        />
                        <Text variant="uiSmall600">
                            Curated by {applylist.curatorName}
                        </Text>
                    </CuratorInfo>
                    <Heading variant="titleLarge">{group.name}</Heading>
                    <Subheading variant="paragraphLarge">
                        {group.description}
                    </Subheading>
                    <ButtonSection />
                </Layout>
            </Background>
        </>
    )
}

FallbackVersion.fragment = FallbackVersionFragment
export default FallbackVersion

const Background = styled.div`
    position: absolute;
    left: 0;
    top: 64px;
    bottom: 0;
    right: 0;
`

const BGImage = styled(DesktopOnly)`
    position: absolute;
    width: 100%;
    height: 100%;
    z-index: -1;
`

const Layout = styled.div`
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    text-align: center;
    ${mq({ margin: ["0px 16px", "0px 20vw"] })}
`

const CuratorInfo = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: ${theme.space.small};
`

const CuratorImage = styled(Image)`
    object-fit: cover;
    margin-right: ${theme.space.xsmall};
`

const Heading = styled(Text)`
    margin-bottom: ${theme.space.xsmall};
`

const Subheading = styled(Text)`
    margin-bottom: ${theme.space.medium};
`
